export default __webpack_public_path__ + "assets/fc37c50adc77aa6e7230e886a47cc034.jpg";